export default __webpack_public_path__ + "static/media/B.01b80039.wav";